import * as React from 'react';
import { connect } from 'react-redux';

import { getPhaseIdByChannelId, getMatchCountdownByChannelId } from '../reducers/timings';
import { getActiveChannelId } from '../reducers/gui';
import { getStaticText 		} from "../reducers/staticTexts"  ;
import { getTranslations	} from "../reducers/translations" ;

import CallToActionPresentation from '../presentations/CallToAction/CallToActionPresentation';

const mapStateToProps = ( state: any ) => {
    const channelId: number = getActiveChannelId( state );
    
    return (
        {
            phaseId: getPhaseIdByChannelId( state, channelId ),
            countdown: getMatchCountdownByChannelId(state, channelId),
            staticTexts: getStaticText( state ),
            translations: getTranslations( state ),
            activeChannelId: channelId,
        }
    )
};

export default connect( mapStateToProps, {} )( CallToActionPresentation )